// utils/yupConfig.js
import * as yup from 'yup';


const spanishMessages = {
  mixed: {
    default: 'Campo no válido',
    required: 'Este campo es obligatorio',
    oneOf: 'Debe ser uno de los siguientes valores: ${values}',
    notOneOf: 'No puede ser uno de los siguientes valores: ${values}',
  },
  string: {
    length: 'Debe tener exactamente ${length} caracteres',
    min: 'Mínimo ${min} caracteres',
    max: 'Máximo ${max} caracteres',
    email: 'Formato de email inválido',
    url: 'Debe ser una URL válida',
    trim: 'No debe contener espacios al inicio o final',
    lowercase: 'Debe estar en minúsculas',
    uppercase: 'Debe estar en mayúsculas',
  },
  number: {
    required: 'Este campo es obligatorio',
    min: 'Mínimo ${min}',
    max: 'Máximo ${max}',
    lessThan: 'Debe ser menor que ${less}',
    moreThan: 'Debe ser mayor que ${more}',
    positive: 'Debe ser un número positivo',
    negative: 'Debe ser un número negativo',
    integer: 'Debe ser un número entero',
  },
  date: {
    typeError: 'La fecha no es válida',
    required: 'Este campo es obligatorio',
    min: 'Debe ser posterior a ${min}',
    max: 'Debe ser anterior a ${max}',
  },
};


const englishMessages = {
  mixed: {
    default: 'Not valid field',
    required: 'Required field',
    oneOf: 'Must be one of the following: ${values}',
    notOneOf: 'Must not be one of the following: ${values}',
  },
  string: {
    length: 'Must have ${length} characters exactly',
    min: 'Minimum ${min} characters',
    max: 'Maximum ${max} characters',
    email: 'Invalid format email',
    url: 'Must be a valid URL',
    trim: 'Must not have espaces at the begining or at end',
    lowercase: 'Must be lowercase',
    uppercase: 'Must be uppercase',
  },
  number: {
    required: 'Required field',
    min: 'Minimum ${min}',
    max: 'Maximum ${max}',
    lessThan: 'Must be less than ${less}',
    moreThan: 'Must be more than ${more}',
    positive: 'Must be a positive number',
    negative: 'Must be a negative number',
    integer: 'Must be a number without decimals',
  },
  date: {
    typeError: 'Not valid date',
    required: 'Required field',
    min: 'Must be after to ${min}',
    max: 'Must be previous to ${max}',
  },
};


export const configureYup = (language) => {
    const messages = language === 'en' ? englishMessages : spanishMessages;
    yup.setLocale(messages);
    return yup;
};


export default yup;